<template>
<div class="aup-like d-flex align-items-center"
    :class="[
		textPlacement === 'bottom' ? 'flex-column' : '', (textPlacement === 'left') ? 'flex-row-reverse' : '',
		( !isSelf && loggedIn ) ? 'aup-like--active' : ''
		]"
    >
	<div
		class="aup-like__tooltip-hover position-relative"
	>
		<!-- SHOW LIKE COUNT ON HOVER WHEN LOGGED IN (GALLERY VIEW) -->
		<p
			class="text-white t-micro t-micro--regular aup-like-count"
			v-if="loggedIn && showCountOnHover"
		>error:call:9</p>

		<!-- OFFSET PROFILE LOGIN GATE TOOLTIP -->
		<p
			class="text-white t-regular aup-like__tooltip"
			:class="{ 'aup-like__tooltip--offset-right' : profileView }"
			v-if="offsetTooltip && !loggedIn && likeType == 'profile'"
		>Create a Public Profile to like profiles</p>

		<!-- LIKE PHOTOS GATE TOOLTIP -->
		<p
			class="text-white t-regular aup-like__tooltip aup-like__tooltip--photo-login-gate "
			v-if="!loggedIn && likeType == 'media'"
			:class="[
				profileView ? 'aup-like__tooltip--top-right' : 'aup-like__tooltip--bottom-right'
			]"
		>Create a Public Profile to like photos</p>

		<button
			:disabled="isSaving || isSelf || !loggedIn"
			class="aup-like__button d-flex"
			:class="[
				(isSelf || !loggedIn) ? 'aup-like__button--disabled' : '',
				(textPlacement === 'bottom') ? 'flex-column' : '',
			]"
			@click="saveContentLikeStatus($event)"
			aria-label="Like"
			>
			<p
				v-if="showCount && ( calcLikeCount > 0 ) && textPlacement === 'left'"
				class="text-white t-bold align-self-center mb-0 mr-1"
				>error:call:10</p>
			<IconHeart
				:height="height"
				:width="width"
				:active="likeStatus && !isSelf"
				class="aup-like__icon"
				:class="{ 'aup-like__icon--saving': isSaving }"
			/>
			<p
				v-if="showCount && ( calcLikeCount > 0 ) && textPlacement !== 'left'"
				:class="[
					(textPlacement === 'right') ? 'ml-2' : '',
					(textPlacement === 'bottom') ? 'mt-3' : '',
				]"
				class="text-white t-bold align-self-center mb-0"
				>error:call:11</p>
		</button>
	</div>
</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'BaseLikeButton',
    computed: {
        ...mapState('Public', {
            profileIsLiked: 'isLiked',
        }),
        likeStatus() {
            if (this.likeType === 'profile') {
                return this.profileIsLiked;
            }
            if (this.likeType === 'media') {
                return this.isLiked;
            }
            return false;
        },
        calcLikeCount: {
            get() {
                if(this.likeType === 'profile') {
                    return this.$store.state.Public.publicUser.profile.ppd_profilelikes;
                }
                else if(this.likeType === 'media') {
                    return this.likeCount;
                }
            },
        },
    },
    props: {
        isDisabled: {
            type: Boolean,
            default: true
        },
        isSelf: {
            type: Boolean,
            default: false
        },
        loggedIn: {
            type: Boolean,
            default: false
        },
        likedContent: {
            type: String,
            default: ''
        },
        likeType: {
            type: String,
            default: ''
        },
        isLiked: {
            type: Boolean,
            default: false
        },
        likeCount: {
            type: Number,
            default: 0,
        },
        height: {
            type: Number,
            default: 24
        },
        width: {
            type: Number,
            default: 24
        },
        showCount: {
            type: Boolean,
            default: true,
        },
        textPlacement: {
            type: String,
            default: 'right'
        },
        profileView: {
            type: Boolean,
            default: false
		},
		showCountOnHover: {
			type: Boolean,
			default: false,
		},
		offsetTooltip: {
			type: Boolean,
			default: false,
		},
    },
    data() {
        return {
            isSaving: false,
        };
    },
    methods: {
        async saveContentLikeStatus(event) {
            event.stopPropagation();
            this.isSaving = true;
            let likeObj = {
                likeType: this.likeType,
                likerGUID: $cookies.get("au_guid"),
                likedContent: this.likedContent
            };
            switch (likeObj.likeType) {
                case 'profile':
                    await this.$store.dispatch('Public/saveProfileLikes', likeObj);
                    this.isSaving = false;
                    break;
                case 'media':
                    if(this.profileView) {
                        await this.$store.dispatch('Public/saveProfileImageLikes', likeObj);
                    } else {
                        await this.$store.dispatch('saveImageLikes', likeObj);
                    }
                    this.isSaving = false;
                    break;
                default:
                    break;
            }
        },
    }
};
</script>
<style lang="scss">
@import '../../assets/scss/all.scss';

.aup-like-count {
	position: absolute;
	visibility: hidden;
	opacity: 0;
	min-width: 30px;
	border-radius: 5px;
	background-color: $primary;
	text-align: center;
	font-family: $font-family-bold;
	font-size: 0.75rem;
	transition: all 0.3s ease-in-out;
	padding: 0 4px;
	transform: translateX(-50%);
	z-index: 1;
	left: 50%;
	pointer-events: none;
	cursor: default;
	&:after {
		content: '';
		position: absolute;
		border-style: solid;
		display: block;
		left: 50%;
		transform: translateX(-50%);
		border-color: $primary transparent;
		border-width: 5px 5px 0;
	}
}

.aup-like {
    &--active {
        &:hover {
            cursor: pointer;
            .aup-like__icon {
                transform: scale(0.8);
            }
        }
    }

    &__count {
        margin-top: -1px;
    }

    &__button {
        background: none;
        padding: 0;
        outline: none;
        box-shadow: none;
        border: none;
        display: inline-flex;

        &:focus {
            outline: none;
            .aup-like__icon {
                transform: scale(0.8);
                opacity: 0.9;
            }
        }

        &--disabled {
            &:hover, &:focus {
                .aup-like__icon {
                    transform: none;
                }
				.aup-like {
					cursor: default;
				}
            }
        }
	}

	&__tooltip {
		position: absolute;
		visibility: hidden;
		opacity: 0;
		min-width: 30px;
		border-radius: 5px;
		background-color: $primary;
		text-align: center;
		font-family: $font-family-bold;
		font-size: 0.75rem;
		left: 0;
		transition: all 0.3s ease-in-out;
		padding: .65rem;
		width: 110px;
		margin-bottom: 0;
		z-index: 1;
		pointer-events: none;
		cursor: default;
		// for comm gallery
		&--bottom-right {
			left: 100%;
			transform: translateX(-100%) translateY(-50%);
		}
		// for photo card & photo details
		&--top-right {
			left: 100%;
			transform: translateX(-100%);
		}
		&--offset-right {
			top: 50%;
			transform: translateY(-50%);
			left: 150%;
			&:before {
				content: '';
				right: 100%;
				top: 50%;
				border: solid transparent;
				position: absolute;
				pointer-events: none;
				border-color: rgba(136, 183, 213, 0);
				border-right-color: $primary;
				border-width: 10px;
				transform: translateY(-50%);
			}
		}
	}

	&__tooltip-hover:hover {
		.aup-like__tooltip, .aup-like-count, .aup-like__offset-tooltip {
			opacity: 1;
			visibility: visible;
		}

		.aup-like-count {
			transform: translateY(-30px) translateX(-50%);
		}
	}

    &__icon {
        transition: 0.3s ease-in-out;
        vertical-align: middle;
        &--saving {
            opacity: 0.8;
            animation: pulse 1s infinite ease-in-out;
        }

        &:focus, path:focus {
            outline: none;
        }
    }

    @keyframes pulse {
        0% {
            opacity: 0.7;
            transform: scale(1)
        }
        50% {
            opacity: 0.9;
            transform: scale(0.8);
        }
        100% {
            opacity: 0.7;
            transform: scale(1);
        }
    }
}
</style>
